import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { Breakpoints } from "styles/breakpoints";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const NavGroupContainer = styled.div`
  justify-content: space-around;
  flex-grow: 1;
  padding-right: 0;

  @media (max-width: ${Breakpoints.Small}) {
    background-color: ${colours.elexonBlue};
    padding: 0;
  }
`;

export const FlexDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 1vw;
  width: 100%;

  .navbar-start {
    display: flex;
    align-items: stretch;
    gap: 8px;
    padding-left: 12px;
    margin: 0;
  }

  @media (max-width: ${Breakpoints.Large}) {
    .navbar-start {
      gap: 6px;
      padding-left: 8px;
    }
  }

  @media (max-width: ${Breakpoints.Medium}) {
    .navbar-start {
      gap: 4px;
      padding-left: 6px;
    }
  }

  @media (max-width: ${Breakpoints.Small}) {
    flex-direction: column;
    gap: 1rem;
    padding-right: 0;

    .navbar-start {
      flex-direction: column;
      align-items: flex-start;
      padding-left: 0;
      padding-bottom: 0;
    }
  }
`;

export const StyledNav = styled.nav`
  position: relative;
  background-color: ${colours.elexonBlue};
  width: 100%;
  min-height: 60px;

  .has-dropdown {
    position: static;
  }

  @media (min-width: ${Breakpoints.Small}) {
    .has-dropdown .navbar-dropdown {
      display: block;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transition: opacity 150ms ease, transform 150ms ease,
        visibility 0s linear 150ms;
    }

    .has-dropdown.is-open .navbar-dropdown {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
      transform: translateY(0);
      transition: opacity 150ms ease, transform 150ms ease,
        visibility 0s linear 0s;
    }
  }

  @media (max-width: ${Breakpoints.Small}) {
    .navbar-menu.is-active {
      position: absolute;
      left: 0;
      right: 0;
      top: 60px;
      max-height: calc(100vh - 60px);
      overflow-y: auto;
      padding: 0;
      background-color: ${colours.elexonBlue};
      z-index: 50;
    }
  }

  .navbar-brand {
    align-items: center;

    @media (max-width: ${Breakpoints.Small}) {
      border-bottom: 2px solid ${colours.elexonBlack};
      padding: 0 1rem;
    }
  }

  .navbar-burger {
    color: ${colours.white};

    span {
      background-color: ${colours.white};
    }
  }
`;

export const MobileHeader = styled.div`
  display: none;

  @media (max-width: ${Breakpoints.Small}) {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-grow: 1;
  }
`;

export const MenuButton = styled.button`
  display: none;
  background-color: ${colours.white};
  border: none;
  border-radius: 4px;
  color: ${colours.elexonBlue};
  font-weight: ${fontWeights.semiBold};
  font-size: 14px;
  padding: 6px 20px;
  cursor: pointer;
  margin: 0.5rem 1rem;
  white-space: nowrap;

  @media (max-width: ${Breakpoints.Small}) {
    display: block;
  }

  &:hover {
    background-color: #f0f0f0;
  }
`;

const insightsLogoBase = css`
  color: ${colours.white};
  font-weight: ${fontWeights.heavy};
  text-transform: uppercase;
  border-right: 1px solid white;
  text-decoration: none;

  &:hover {
    color: ${colours.white};
  }
`;

export const DesktopInsightsLogo = styled(Link)`
  ${insightsLogoBase};
  background-color: ${colours.elexonBlue};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.7em;
  padding: 0 12px 0 36px;

  @media (max-width: ${Breakpoints.Medium}) {
    padding: 0 12px 0 10px;
  }

  @media (max-width: ${Breakpoints.Small}) {
    display: none;
  }
`;

export const MobileInsightsLogo = styled(Link)`
  ${insightsLogoBase};
  display: none;
  font-size: 28px;
  padding: 1rem;

  @media (max-width: ${Breakpoints.Small}) {
    display: block;
  }
`;
